import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const allCats = categories;

  return (
    <section id="categorie" className="relative bg-foreground-950 py-20 md:py-28 overflow-hidden">
      {/* Background subtle texture */}
      <div className="absolute inset-0 opacity-[0.02] bg-repeat" style={{
        backgroundImage: 'radial-gradient(circle, oklch(var(--background-50)) 1px, transparent 1px)',
        backgroundSize: '20px 20px',
      }}></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <span className="inline-block px-4 py-1.5 border border-background-50/20 rounded-full text-xs text-background-50/60 mb-4 font-label">
              Itaobuy
            </span>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
              Categorie<br />Prodotto
            </h2>
          </div>
          <p className="text-background-50/50 text-sm max-w-md lg:text-right">
            Esplora tutte le categorie disponibili su Itaobuy Spreadsheet. Ogni categoria è costantemente aggiornata con nuovi prodotti.
          </p>
        </div>

        {/* Scrollable cards */}
        <div className="relative">
          <div
            id="category-scroll"
            className="flex gap-5 overflow-x-auto scrollbar-hide pb-4 -mx-4 px-4 scroll-smooth"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {allCats.map((cat) => (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex-shrink-0 w-64 md:w-72 group cursor-pointer"
              >
                <div className="relative aspect-square rounded-xl overflow-hidden mb-4 bg-background-100">
                  <img
                    src={cat.imageUrl}
                    alt={cat.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 via-transparent to-transparent"></div>
                </div>
                <div>
                  <h3 className="text-background-50 font-semibold text-sm group-hover:text-accent-300 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-background-50/50 text-xs mt-1">
                    {cat.description}
                  </p>
                </div>
              </a>
            ))}
          </div>

          {/* Scroll arrows */}
          <button
            onClick={() => {
              const container = document.getElementById('category-scroll');
              if (container) container.scrollBy({ left: -320, behavior: 'smooth' });
            }}
            className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 w-10 h-10 items-center justify-center rounded-full bg-background-50/10 backdrop-blur-sm text-background-50 hover:bg-background-50/20 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>
          <button
            onClick={() => {
              const container = document.getElementById('category-scroll');
              if (container) container.scrollBy({ left: 320, behavior: 'smooth' });
            }}
            className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 w-10 h-10 items-center justify-center rounded-full bg-background-50/10 backdrop-blur-sm text-background-50 hover:bg-background-50/20 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}